<template>
	<treeBody>
		<cameraTree slot="tree" :dataList="cameraTree" :maxSelectedNum="9" @checkItem="checkItem($event)" @beyondMaxSelect="beyondMaxSelect"></cameraTree>
		<!--播放界面-->
		<div slot="body" class="container">
			<div id="divPlugin" class="plugin"></div>
		</div>
	</treeBody>
</template>
<script>
	import { WebVideoCtrl } from "../../../public/static/js/webVideoCtrl.js";
	import cameraTree from '@/components/module/tree/cameraTree.vue'
	import treeBody from '@/components/module/slotModule/treeBody.vue'
	export default {
		components: {
			cameraTree,
			treeBody
		},
		data() {
			return {
				hkvInfo: {
					ip: "192.168.0.177", //海康威视摄像头/硬盘录像机的ip地址
					port: "80", //海康威视摄像头/硬盘录像机的端口
					username: "admin", //海康威视摄像头/硬盘录像机的用户名
					//password: "admin12345", //海康威视摄像头/硬盘录像机的密码
					password: "wedo123456", //海康威视摄像头/硬盘录像机的密码
					channels: [] //海康威视摄像头/硬盘录像机的通道
				},
				mySelectWnd: 0, //当前选中的窗口
				g_bPTZAuto: false,
				iProtocol: 1,
				loginLoading: false,
				startPlayLoading: false,
				iStreamType: 1,
				bZeroChannel: false,
				iRtspPort: 0,
				cameraTree: [],
			};
		},
		created: function() {},
		mounted: function() {
			this.$api.cameraApi.getCameraTree(respon => {
				if(respon != undefined) {
					this.cameraTree = respon
					console.log(this.cameraTree)
				}
			})
			this.videoInitPlugin(); // 初始化video界面
			//this.onLogin();
			//this.clickStartRealPlay();
		},

		destroyed: function() {
			this.clickStopRealPlay();
			this.onLogout();
		},
		methods: {
			checkItem(list) {
				this.hkvInfo.ip=list.remote_ip
			  /*this.hkvInfo.port=list.remote_port*/
			  this.hkvInfo.username=list.remote_user
			  this.hkvInfo.password=list.remote_pwd
			  this.change()
			},
			beyondMaxSelect() {
				this.$dialogMethod.showMessage('最多可选择显示九个摄像头画面！')
			},
			onLogin() {
				var that = this;
				// that.loginLoading = true;
				// 登录设备
				console.log(WebVideoCtrl)
				WebVideoCtrl.I_Login(
					that.hkvInfo.ip,
					that.iProtocol,
					that.hkvInfo.port,
					that.hkvInfo.username,
					that.hkvInfo.password, {
						async: false,
						success: function(xmlDoc) {
							// console.log('xmlDoc2', xmlDoc);//不能删除
							//TODO 获取通道信息
							that.getChannelInfo();
							that.getDevicePort(that.hkvInfo.ip + "_" + that.hkvInfo.port);
							// that.loginLoading = false;

							// that.$message({
							//   showClose: true,
							//   message: "登录成功",
							//   type: "success"
							// });
						},
						error: function() {
							// that.loginLoading = false;
							that.$message({
								showClose: true,
								message: "登录失败",
								type: "error"
							});
						}
					}
				);
			},
			onLogout() {
				this.hkvInfo.channels = [];
				var szDeviceIdentify = this.hkvInfo.ip + "_" + this.hkvInfo.port;
				var iRet = WebVideoCtrl.I_Logout(szDeviceIdentify);
			},
			clickStartRealPlay() {
				// 开始预览
				var that = this;
				// that.startPlayLoading = true;
				var szDeviceIdentify = that.hkvInfo.ip + "_" + that.hkvInfo.port;

				var j =
					that.hkvInfo.channels.length > 4 ? 4 : that.hkvInfo.channels.length;
				for(var i = 0; i < j; i++) {
					setTimeout(
						that.startRealPlay(szDeviceIdentify, i, that.hkvInfo.channels[i]),
						500
					);
				}
				// that.startPlayLoading = false;
			},
			videoInitPlugin: function() {
				// 检查插件是否已经安装过
				var iRet = WebVideoCtrl.I_CheckPluginInstall();
				if(-2 == iRet) {
					alert("您的Chrome浏览器版本过高，不支持NPAPI插件！");
					return;
				} else if(-1 == iRet) {
					alert("您还未安装过插件，双击开发包目录里的WebComponentsKit.exe安装！");
					return;
				}
				this.initPlugin();
			},
			initPlugin: function() {
				var that = this;

				WebVideoCtrl.I_InitPlugin(1420, 1100, {
					bWndFull: true, //是否支持单窗口双击全屏，默I_CheckPluginInstall
					iWndowType: 1,
					myCbSelWnd: function(xmlStr) {
						//自己新增的方法
						var jsonObj = that.$x2js.xml2js(xmlStr);
						that.mySelectWnd = jsonObj.RealPlayInfo.SelectWnd;
						var szInfo = "当前选择的窗口编号：" + that.mySelectWnd;
						console.log(szInfo);
					},
					cbInitPluginComplete: function() {
						WebVideoCtrl.I_InsertOBJECTPlugin("divPlugin");
						// 检查插件是否最新
						if(WebVideoCtrl.I_CheckPluginVersion() === -1) {
							alert(
								"检测到新的插件版本，双击开发包目录里的WebComponentsKit.exe升级！"
							);
							return;
						}
					}
				});
			},
			getDevicePort: function(szDeviceIdentify) {
				var oPort = WebVideoCtrl.I_GetDevicePort(szDeviceIdentify);
				this.iRtspPort = oPort.iRtspPort;
			},
			startRealPlay: function(szDeviceIdentify, iWndIndex, iChannelID) {
				var that = this;
				WebVideoCtrl.I_StartRealPlay(szDeviceIdentify, {
					iRtspPort: that.iRtspPort,
					iWndIndex: iWndIndex,
					iStreamType: 1,
					iChannelID: iChannelID,
					bZeroChannel: that.bZeroChannel,
					success: function() {
						console.log("预览成功")
						/*that.$notify({
							message: "预览成功",
							type: "success"
						});*/
					},
					error: function(status, xmlDoc2) {
						console.log("预览失败",status)
						that.$notify({
							message: "预览失败",
							type: "error"
						});
						if(status === 403) {
							console.log("szInfo 设备不支持Websocket取流！");
						} else {
							console.log("开始预览失败 ", status, xmlDoc2);
						}
					}
				});
			},
			clickStopRealPlay: function() {
				var j =
					this.hkvInfo.channels.length > 4 ? 4 : this.hkvInfo.channels.length;
				for(var i = 0; i < j; i++) {
					setTimeout(this.stopRealPlay(i), 1000);
				}
			},
			stopRealPlay: function(iWndIndex) {
				var that = this;
				WebVideoCtrl.I_Stop({
					iWndIndex: iWndIndex,
					success: function() {
						/*that.$notify({
							message: "停止预览",
							type: "success"
						});*/
					},
					error: function() {
						that.$notify({
							// title: "失败",
							message: "停止预览失败",
							type: "error"
						});
					}
				});
			},
			change() {
				var that = this;
				that.clickStopRealPlay();
				this.onLogout();
				console.log(that.hkvInfo);
				that.onLogin();
				that.clickStartRealPlay();
			},
			// 获取通道，实际上可以根据自己的项目，获取数字通道，模拟通道，零通道中的一个或多个，不用全部获取（提高效率）
			getChannelInfo: function() {
				var that = this;
				var szDeviceIdentify = this.hkvInfo.ip + "_" + this.hkvInfo.port;
				// debugger
				// 数字通道
				that.hkvInfo.channels = [];
				WebVideoCtrl.I_GetDigitalChannelInfo(szDeviceIdentify, {
					async: false,
					mysuccess: function(xmlStr) {
						console.log("mysuccess I_GetDigitalChannelInfo: ", xmlStr);
						var jsonObj = that.$x2js.xml2js(xmlStr);
						var list =
							jsonObj.InputProxyChannelStatusList.InputProxyChannelStatus;
						for(var x = 0; x < list.length; x++) {
							that.hkvInfo.channels.push(list[x].id);
						}
					},
					success: function(xmlDoc) {},
					error: function(status, xmlDoc) {
						console.log("获取数字通道失败");
					}
				});
				// TODO 模拟通道
				// 模拟通道
				WebVideoCtrl.I_GetAnalogChannelInfo(szDeviceIdentify, {
					async: false,
					mysuccess: function(xmlStr) {
						var jsonObj = that.$x2js.xml2js(xmlStr);
						console.log("模拟通道mysuccess", xmlStr);
						var id = jsonObj.VideoInputChannelList.VideoInputChannel.id;
						that.hkvInfo.channels.push(id);
					},
					success: function(xmlStr) {
						console.log("模拟通道success", xmlStr);
					},
					error: function(status, xmlDoc) {
						console.log("模拟通道error", xmlDoc);
					}
				});
				// TODO 零通道
			},
		}
	};
</script>

<style scoped>
	.plugin {
		width: 100%;
		height:100%;
	}
</style>